module.exports = __webpack_public_path__ + "static/media/yogamusiq.2aab9e7d.svg";